export default {
    topics: [
        {
            title: ' HttpSoapConnection ',
            href: 'm-HttpSoapConnection-HttpSoapConnection.html',
            attributes: { 'data-id': 'm-HttpSoapConnection-HttpSoapConnection' },
            menu: { hasChildren: false },
            tocID: 'm-HttpSoapConnection-HttpSoapConnection-d66e5514',
            topics: [],
        },
        {
            title: ' addHeader ',
            href: 'm-HttpSoapConnection-addHeader.html',
            attributes: { 'data-id': 'm-HttpSoapConnection-addHeader' },
            menu: { hasChildren: false },
            tocID: 'm-HttpSoapConnection-addHeader-d66e5522',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-HttpSoapConnection-dispose.html',
            attributes: { 'data-id': 'm-HttpSoapConnection-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-HttpSoapConnection-dispose-d66e5530',
            topics: [],
        },
        {
            title: ' setHeader ',
            href: 'm-HttpSoapConnection-setHeader.html',
            attributes: { 'data-id': 'm-HttpSoapConnection-setHeader' },
            menu: { hasChildren: false },
            tocID: 'm-HttpSoapConnection-setHeader-d66e5538',
            topics: [],
        },
    ],
};

